import axios from 'axios';

// const URL = 'http://localhost:4000'
const URL = process.env.REACT_APP_BASE_URL || 'https://api.careerroshi.com' 

export const GetFilterJobSeeker = async ( filter ) => {
    const res = await axios.post(`${URL}/report/coach/get`, filter)
    return res;
}

export const GetSavedFilters = async ( userId , search, type = 'ORGANIZATION-COACHES' ) => {
    const res = await axios.get(`${URL}/report/saved-filter/get`, {
        params: {
            userId,
            type,
            search
        }
    })
    return res.data;
}

export const GetCoachesByOrgId = async (orgId, search = '') => {
    const res = await axios.get(`${URL}/organization/coaches/${orgId}`, {
        params: {
            type: "ORGANIZATION",
            search
        }
    })
    return res.data;
}

export const DeleteSavedFilter = async (id) => {
    const res = await axios.delete(`${URL}/report/saved-filter/${id}`);
    return res.data
}

export const GetOccupationList = async (name)=>{
    const res = await axios.get(`${URL}/occupation/interest/list`, {
        params: {
            search: name
        }
    })
    return res.data;
}

export const UpdateFilter = async ( filter ) => {
    const res = await axios.post(`${URL}/report/coach/update`, filter)
    return res.data;
}
export const GetSaveFilter = async ( id ) => {
    const res = await axios.get(`${URL}/report/filter/${id}`)
    return res.data;
}

export const SaveFilter = async ( filter ) => {
    const res = await axios.post(`${URL}/report/coach/save`, filter)
    return res.data;
}

export const GetUserDetails = async (org_id, name)=>{
    const res = await axios.get(`${URL}/organization/coaches/user/source/platform`, {
        params: {
            search: name,
            org_id
        }
    })
    return res.data;
}
